import React from 'react';
import { Row } from 'hedron';
import PropTypes from 'prop-types';
import { Desktop, Mobile } from '../MediaQuery';
import ShowDepartmentsDiv from './styled/ShowDepartmentsDiv';

const SearchDepartment = ({ children, showDepartments }) => (
  <>
    <Mobile>
      <Row justifyContent="space-around" style={{ marginTop: '10px' }}>
        {children}
      </Row>
    </Mobile>
    <Desktop>
      <ShowDepartmentsDiv showDepartments={showDepartments}>{children}</ShowDepartmentsDiv>
    </Desktop>
  </>
);

SearchDepartment.propTypes = {
  showDepartments: PropTypes.bool,
};

export default SearchDepartment;
